import { translations } from './assets/translations.js'

export default {
    translations: translations
}